import { defineElement, FC, useElement, useListen } from '@atomify/hooks';
import { Fragment, h } from '@atomify/jsx';
import getComponentData from '@atoms/component-data/utils/get-component-data';
import { elements } from '@utilities/dom';
import { getAssetsFolder } from '@utilities/get-assets-folder';
import { useStylesheet } from '@utilities/hooks';

import style from './map-switch.scss';
import MapSwitchToggle from './utilities/map-switch-toggle';

interface ToggleInterface {
    label: string;
    image: string;
}

interface DataInterface {
    interiorToggle: ToggleInterface;
    exteriorToggle: ToggleInterface;
}

const VIEW_EXTERIOR = 'map-switch--view-exterior';
const THUMBNAIL_EXTERIOR = getAssetsFolder('/images/map-switch-thumbnail-exterior.jpg');
const THUMBNAIL_INTERIOR = getAssetsFolder('/images/map-switch-thumbnail-interior.jpg');

export class BPDMapSwitch extends HTMLElement {}

const MapSwitch: FC = ({ element }) => {
    useStylesheet(style);

    const container = useElement<HTMLElement>('[js-hook-map-switch]');
    const toggleButton = useElement<HTMLButtonElement>('[js-hook-map-switch-toggle]');

    const data: DataInterface | null = getComponentData<DataInterface>(element);

    setDefaultImages();
    // onDidLoad(() => {
    // });

    function setDefaultImages() {
        if (!data) return;

        if (!data.interiorToggle.image) data.interiorToggle.image = THUMBNAIL_INTERIOR;

        if (!data.exteriorToggle.image) data.exteriorToggle.image = THUMBNAIL_EXTERIOR;
    }

    useListen(toggleButton, 'click', toggle);
    function toggle() {
        // Toggle class on both body and component, because component has shadowDOM
        container.current?.classList.toggle(VIEW_EXTERIOR);
        elements.body.classList.toggle(VIEW_EXTERIOR);
    }

    return (
        <div class="c-map-switch" js-hook-map-switch>
            <div class="map-switch__container">
                <div class="map-switch__interior">
                    <slot name="interior"></slot>
                </div>

                <div class="map-switch__exterior">
                    <slot name="exterior"></slot>
                </div>

                <button class="map-switch__toggle" js-hook-map-switch-toggle>
                    {data?.interiorToggle && data?.exteriorToggle && (
                        <Fragment>
                            <MapSwitchToggle
                                className="map-switch__toggle-exterior"
                                {...data.exteriorToggle}
                            />
                            <MapSwitchToggle
                                className="map-switch__toggle-interior"
                                {...data.interiorToggle}
                            />
                        </Fragment>
                    )}
                </button>
            </div>
        </div>
    );
};

defineElement('bpd-map-switch', MapSwitch, { useShadowDom: true });
